import * as React from 'react';
import MailModule from './MailModule';
import strings from 'owa-strings/owa-mini-common-strings';
import { AriaLiveWrapper } from 'mini-accessibility';
import { observer } from 'mobx-react';

/**
 * Component which serves as a wrapper over the main mailmodule component
 * All the components which need to be fetched on boot but need not be shown for optimisation pusporse can be added inside the
 * div with display:'none to ensure that the component is already loaded when it needs to be invoked
 * Please note that this will load the component on boot time, adding some delay there instead of later
 *
 * @param props
 */

export default observer(function MailModuleWrapper(props: {}): JSX.Element {
    const wrapperRef = React.createRef<HTMLDivElement>();

    return (
        <div ref={wrapperRef} tabIndex={0} role="main" aria-label={strings.moduleMailLabel}>
            <MailModule />
            <AriaLiveWrapper />
        </div>
    );
});
